import React from "react";
import AboutUsHero from "./AboutUsHero";
import OurServices from "./OurServices";
import Our_Mission_Vision from "./Our_Mission_Vision";
import Ourteam from "./Ourteam";
import CertificateCard_Section from "./CertificateCard_Section";
import Enquiery from "./Enquiery";
import Backed from "./Backed";

const AboutUs = () => {
    return (
        <>
            <AboutUsHero />
            <OurServices />
            <Our_Mission_Vision />
            <Ourteam />
            <Enquiery />
            <Backed />
            {/* <CertificateCard_Section /> */}
        </>
    );
};

export default AboutUs;
